import styles from './create-new-catalog-dialog.module.scss';
import BaseCatalogDialog from '../../../base-catalog-dialog/base-catalog-dialog';
import { ICatalogItem } from '../../../_models/catalog-item';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CreateNewCatalogDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void
}

export function CreateNewCatalogDialog(props: CreateNewCatalogDialogProps) {
  const { t } = useTranslation();

  const catalogItem: ICatalogItem = {
    adskCourseId: "",
    courseDescription: "",
    courseIngress: "",
    courseName: "",
    doNotPublish: false,
    iconUrl: "",
    link: "",
    dt: "Catalog",
    categories: [],
    relationProductIds: [],
    isDeleted: false
  };

  return <BaseCatalogDialog
    catalogItem={catalogItem}
    onClose={props.onClose}
    open={props.open}
    refreshData={props.refreshData}
    handleOkText={t("standard.addCourse")}
    headerText={t("standard.newCourse")}
  />
}

export default CreateNewCatalogDialog;